import '@masar/tokens/all.css';
import { createMasarClient } from '@masar/api-client';
import { ApiProvider } from '@masar/api-client/query';
import { ToastProvider } from '@masar/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { currentLocale, PrefsProvider } from './app/locale';
import './app/problems';

const client = createMasarClient({ baseUrl: '/api', locale: currentLocale });

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <PrefsProvider>
      <ApiProvider client={client}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </ApiProvider>
    </PrefsProvider>
  </StrictMode>,
);
